export default __webpack_public_path__ + "static/media/1792.c3004b0c.png";